export const ordersQueryKeys = {
  orders: 'orders',
  order: 'order',
};

export const deliveryStatusEndpoint = '/v2/orders/status/';
